export const safeParseObjectFromLocalStorage = (key: string) => {
  const nonParsedItemFromSessionStorage = localStorage.getItem(key);

  if (typeof nonParsedItemFromSessionStorage === 'string') {
    try {
      return JSON.parse(nonParsedItemFromSessionStorage);
    } catch {
      return null;
    }
  } else {
    return null;
  }
};
